import _defineProperty from "@babel/runtime/helpers/defineProperty";
export default class RefsManager {
  constructor(base, element, refs, eventsManager) {
    _defineProperty(this, "__element", void 0);

    _defineProperty(this, "__refs", void 0);

    _defineProperty(this, "__base", void 0);

    _defineProperty(this, "__eventsManager", void 0);

    Object.defineProperties(this, {
      __element: {
        enumerable: false,
        writable: false,
        value: element
      },
      __refs: {
        enumerable: false,
        writable: false,
        value: refs
      },
      __base: {
        enumerable: false,
        writable: false,
        value: base
      },
      __eventsManager: {
        enumerable: false,
        writable: false,
        value: eventsManager
      }
    });
  }

  registerAll() {
    this.__refs.forEach(refName => this.__register(refName));
  }

  unregisterAll() {
    this.__refs.forEach(refName => this.__unregister(refName));
  }

  __register(refName) {
    var isMultiple = refName.endsWith('[]');
    var propName = RefsManager.normalizeRefName(refName);
    var refs = Array.from(this.__element.querySelectorAll("[data-ref=\"".concat(refName, "\"]"))).filter(ref => this.__filterRefsBelongingToInstance(ref));

    if (!isMultiple && refs.length > 1) {
      console.warn("[".concat(this.__base.$options.name, "]"), "The \"".concat(refName, "\" ref has been found multiple times."), 'Did you forgot to add the `[]` suffix to its name?');
    }

    this.__eventsManager.bindRef(refName, refs);

    Object.defineProperty(this, propName, {
      value: isMultiple || refs.length > 1 ? refs : refs[0],
      enumerable: true,
      configurable: true
    });
  }

  __unregister(refName) {
    var propName = RefsManager.normalizeRefName(refName);
    var refs = Array.isArray(this[propName]) ? this[propName] : [this[propName]];

    this.__eventsManager.unbindRef(refName, refs);
  }

  static normalizeRefName(name) {
    return name.endsWith('[]') ? name.replace(/\[\]$/, '') : name;
  }

  __filterRefsBelongingToInstance(ref) {
    var ancestor = ref.parentElement;

    while (ancestor && ancestor.dataset.component === undefined) {
      ancestor = ancestor.parentElement;
    }

    return ancestor === null || ancestor === this.__element;
  }

}